import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.css'],
})
export class DeleteDialogComponent {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() showCancelBtn: Boolean = true;
  @Input() deleteButtonText: string = 'Delete';
  @Input() padding: string = '40px';

}
